<template>

  <b-row>

    <b-col
        md="12"
        xl="12"
        class="mb-1"
    >
      <b-card-code :title="type == 1 ? 'Taxipreis anpassen' : 'Preis anpassung'">

        <b-row>
          <b-col
              md="4"
              xl="4"
          >
            <b-form-group
                label="Name"
            >
              <b-form-input
                  v-model="edit.Name"
              />
            </b-form-group>
          </b-col>
          <b-col
              md="4"
              xl="4"
          >
            <b-form-group
                label="Ab. km"
            >
              <b-form-input
                  v-model="edit.FromDistance"
              />
            </b-form-group>
          </b-col>
          <b-col
              md="4"
              xl="4"
          >
            <b-form-group
                label="Gültig ab"
            >
              <b-input-group>
                <b-form-input
                    v-model="edit.ValidFrom"
                    type="text"
                    placeholder="DD.MM.YY"
                    autocomplete="off"
                />
                <b-input-group-append>
                  <b-form-datepicker
                      :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }"
                      button-only
                      :start-weekday="1"
                      locale="de-DE"
                      color="danger"
                      @context="onContext"
                  />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col
              md="4"
              xl="4"
          >
            <b-form-group
                label="Einstieg 1-3"
            >
              <euro-field ref="EuroFieldEnterAmount"/>
            </b-form-group>
          </b-col>
          <b-col
              md="4"
              xl="4"
          >
            <b-form-group
                label="Einstieg 4-8"
            >
              <euro-field ref="EuroFieldEnterAmount2"/>
            </b-form-group>
          </b-col>
          <b-col
              md="4"
              xl="4"
          >
            <b-form-group
                label="Kilometerpreis"
            >
              <euro-field ref="EuroFieldAmount"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>

          <b-col
              md="12"
              xl="12"
              class="mt-1"
          >
            <b-button
                style="float: left"
                class="col-4"
                variant="danger"
                @click="DeleteEntry()"
            >
              <span v-show="!loading"> Löschen  </span>
              <!-- IF YOU ARE USING VUE BOOTSTRAP USE <b-spinner label="Loading..."></b-spinner> -->
              <div
                  v-show="loading"
                  class="spinner-border spinner-border-sm"
                  role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </b-button>
            <b-button
                style="float: right"
                class="col-7"
                variant="info"
                @click="Save()"
            >
              <span v-show="!loading"> Speichern  </span>
              <!-- IF YOU ARE USING VUE BOOTSTRAP USE <b-spinner label="Loading..."></b-spinner> -->
              <div
                  v-show="loading"
                  class="spinner-border spinner-border-sm"
                  role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </b-button>
          </b-col>
        </b-row>

      </b-card-code>
    </b-col>
  </b-row>
</template>


<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BFormDatepicker
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import BCardCode from '@core/components/b-card-code'
import EuroField from '@/views/voucher2/EuroFild.vue'

export default {
  components: {
    BCardCode,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BFormDatepicker,
    EuroField,
  },
  data() {
    return {
      loading: false,
      type: 0,
      edit: {
        Amount: 0,
        EnterAmount: 0,
        EnterAmount2: 0,
        FromDistance: 0,
        IdentId: 0,
        Name: '',
        ValidFrom: null
      }

    }
  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Preise'
    })
    this.type = this.$route.params.type;
    this.Load()
  },
  methods: {
    FormatEuro(euro) {
      return this.$options.filters.currency(euro)
    },
    formatDate(date) {
      return `${new Date(date).toLocaleString('de-DE', {
            year: '2-digit',
            month: '2-digit',
            day: '2-digit'
          },
      )}`
    },
    onContext(ctx) {
      if (ctx.selectedDate) {
        // The date formatted in the locale, or the `label-no - date - selected` string
        this.formatted = ctx.selectedFormatted
        // The following will be an empty string until a valid date is entered
        this.selected = ctx.selectedYMD
        this.edit.ValidFrom= ctx.activeFormatted
        this.value = ctx.activeFormatted
      }
    },
    DeleteEntry() {
      this.$swal({
        title: 'LÖSCHEN',
        text: "Möchten sie diesen Preis wirklich löschen?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, löschen!',
        cancelButtonText: 'Nein, abbrechen',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {

          let url = '/price/delete/';
          if(this.type == 1) {
            url = '/taxi/price/delete/'
          }
          this.$http.delete(url + this.edit.IdentId)
              .then(resp => {
                if(resp.data.success) {
                  this.$swal({
                    icon: 'success',
                    title: 'Gelöscht!',
                    text: 'Preis wurde unwiderruflich gelöscht.',
                    customClass: {
                      confirmButton: 'btn btn-success',
                    },
                  })

                  this.$router.push({ name: 'PriceList' })

                }
              })
              .catch(err => {
                console.error(err)
              })

        }
      })
    },
    Save() {
      console.log(this.edit.ValidFrom)
      let date = new Date(this.edit.ValidFrom.replace(/(.*)\.(.*)\.(.*)/, '20$3-$2-$1'));
      console.log(date)
      if (this.edit.IdentId == 0) {

        let url = '/price/add';
        if(this.type == 1) {
          url = '/taxi/price/add'
        }
        this.$http.post(url, JSON.stringify({
          Name: this.edit.Name,
          FromDistance: parseInt(this.edit.FromDistance),
          EnterAmount: parseFloat(this.$refs.EuroFieldEnterAmount.fieldData.toString().replace(',', '.')),
          EnterAmount2: parseFloat(this.$refs.EuroFieldEnterAmount2.fieldData.toString().replace(',', '.')),
          Amount: parseFloat(this.$refs.EuroFieldAmount.fieldData.toString().replace(',', '.')),
          ValidFrom: date,
        }))
            .then(resp => {
              if (resp.data.success) {
                this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Info',
                        icon: 'CheckIcon',
                        text: 'Preis wurde eingetragen.',
                        variant: 'success',
                      },
                    },
                    {
                      timeout: 5000,
                    })
                this.$router.push({ name: 'PriceList' })

              } else {
                this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Fehler',
                        icon: 'CheckIcon',
                        text: resp.data.message,
                        variant: 'danger',
                      },
                    },
                    {
                      timeout: 5000,
                    })
              }
            })
            .catch(err => {
              this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Fehler',
                      icon: 'CheckIcon',
                      text: 'Es ist ein Fehler aufgetreten',
                      variant: 'danger',
                    },
                  },
                  {
                    timeout: 5000,
                  })
            })
      } else {
        let url = '/price/update';
        if(this.type == 1) {
          url = '/taxi/price/update'
        }

        this.$http.post(url, JSON.stringify({
          Name: this.edit.Name,
          FromDistance: parseInt(this.edit.FromDistance),
          EnterAmount: parseFloat(this.$refs.EuroFieldEnterAmount.fieldData.toString().replace(',', '.')),
          EnterAmount2: parseFloat(this.$refs.EuroFieldEnterAmount2.fieldData.toString().replace(',', '.')),
          Amount: parseFloat(this.$refs.EuroFieldAmount.fieldData.toString().replace(',', '.')),
          ValidFrom: date,
          IdentId: this.edit.IdentId
        }))
            .then(resp => {
              if (resp.data.success) {
                this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Info',
                        icon: 'CheckIcon',
                        text: 'Preis wurde geändert.',
                        variant: 'success',
                      },
                    },
                    {
                      timeout: 5000,
                    })

                this.$router.push({ name: 'PriceList' })
              } else {
                this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Fehler',
                        icon: 'CheckIcon',
                        text: resp.data.message,
                        variant: 'danger',
                      },
                    },
                    {
                      timeout: 5000,
                    })
              }
            })
            .catch(err => {
              this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Fehler',
                      icon: 'CheckIcon',
                      text: 'Es ist ein Fehler aufgetreten',
                      variant: 'danger',
                    },
                  },
                  {
                    timeout: 5000,
                  })
            })
      }
    },
    Load() {
      if(this.$route.params.identId == 0)
        return;

      let url = '/price?identId=';
      if(this.type == 1) {
        url = '/taxi/price?identId='
      }
      this.$http.get(url + this.$route.params.identId)
          .then(resp => {
            console.log(resp)
            this.edit = resp.data.price

            this.$refs.EuroFieldAmount.fieldData = this.edit.Amount
            this.$refs.EuroFieldAmount.Blur()

            this.$refs.EuroFieldEnterAmount.fieldData = this.edit.EnterAmount
            this.$refs.EuroFieldEnterAmount.Blur()

            this.$refs.EuroFieldEnterAmount2.fieldData = this.edit.EnterAmount2
            this.$refs.EuroFieldEnterAmount2.Blur()

            this.edit.ValidFrom = this.formatDate(this.edit.ValidFrom);
          })
          .catch(err => {
            console.error(err)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fehler',
                icon: 'CheckIcon',
                text: err,
                variant: 'danger',
              },
            })
          })
    },
  },
}
</script>
